function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function t(t, i, e, s) {
  return new (e || (e = Promise))(function (r, o) {
    function n(t) {
      try {
        d(s.next(t));
      } catch (t) {
        o(t);
      }
    }

    function a(t) {
      try {
        d(s.throw(t));
      } catch (t) {
        o(t);
      }
    }

    function d(t) {
      var i;
      t.done ? r(t.value) : (i = t.value, i instanceof e ? i : new e(function (t) {
        t(i);
      })).then(n, a);
    }

    d((s = s.apply(t, i || [])).next());
  });
}

var i = /*#__PURE__*/function () {
  function i() {
    _classCallCheck(this, i);

    this.listeners = {};
  }

  _createClass(i, [{
    key: "on",
    value: function on(t, _i, e) {
      var _this = this;

      if (this.listeners[t] || (this.listeners[t] = new Set()), this.listeners[t].add(_i), null == e ? void 0 : e.once) {
        var _e = function _e() {
          _this.un(t, _e), _this.un(t, _i);
        };

        return this.on(t, _e), _e;
      }

      return function () {
        return _this.un(t, _i);
      };
    }
  }, {
    key: "un",
    value: function un(t, _i2) {
      var e;
      null === (e = this.listeners[t]) || void 0 === e || e.delete(_i2);
    }
  }, {
    key: "once",
    value: function once(t, _i3) {
      return this.on(t, _i3, {
        once: !0
      });
    }
  }, {
    key: "unAll",
    value: function unAll() {
      this.listeners = {};
    }
  }, {
    key: "emit",
    value: function emit(t) {
      for (var _len = arguments.length, _i4 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        _i4[_key - 1] = arguments[_key];
      }

      this.listeners[t] && this.listeners[t].forEach(function (t) {
        return t.apply(void 0, _i4);
      });
    }
  }]);

  return i;
}();

var e = /*#__PURE__*/function (_i5) {
  _inherits(e, _i5);

  var _super = _createSuper(e);

  function e(t) {
    var _this2;

    _classCallCheck(this, e);

    _this2 = _super.call(this), _this2.subscriptions = [], _this2.options = t;
    return _this2;
  }

  _createClass(e, [{
    key: "onInit",
    value: function onInit() {}
  }, {
    key: "_init",
    value: function _init(t) {
      this.wavesurfer = t, this.onInit();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.emit("destroy"), this.subscriptions.forEach(function (t) {
        return t();
      });
    }
  }]);

  return e;
}(i);

var s = /*#__PURE__*/function (_i6) {
  _inherits(s, _i6);

  var _super2 = _createSuper(s);

  function s() {
    var _this3;

    _classCallCheck(this, s);

    _this3 = _super2.apply(this, arguments), _this3.unsubscribe = function () {};
    return _this3;
  }

  _createClass(s, [{
    key: "start",
    value: function start() {
      var _this4 = this;

      this.unsubscribe = this.on("tick", function () {
        requestAnimationFrame(function () {
          _this4.emit("tick");
        });
      }), this.emit("tick");
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unsubscribe();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unsubscribe();
    }
  }]);

  return s;
}(i);

var r = ["audio/webm", "audio/wav", "audio/mpeg", "audio/mp4", "audio/mp3"];

var o = /*#__PURE__*/function (_e2) {
  _inherits(o, _e2);

  var _super3 = _createSuper(o);

  function o(t) {
    var _this5;

    _classCallCheck(this, o);

    var i, e, r, _o;

    _this5 = _super3.call(this, Object.assign(Object.assign({}, t), {
      audioBitsPerSecond: null !== (i = t.audioBitsPerSecond) && void 0 !== i ? i : 128e3,
      scrollingWaveform: null !== (e = t.scrollingWaveform) && void 0 !== e && e,
      scrollingWaveformWindow: null !== (r = t.scrollingWaveformWindow) && void 0 !== r ? r : 5,
      renderRecordedAudio: null === (_o = t.renderRecordedAudio) || void 0 === _o || _o
    })), _this5.stream = null, _this5.mediaRecorder = null, _this5.dataWindow = null, _this5.isWaveformPaused = !1, _this5.lastStartTime = 0, _this5.lastDuration = 0, _this5.duration = 0, _this5.timer = new s(), _this5.subscriptions.push(_this5.timer.on("tick", function () {
      var t = performance.now() - _this5.lastStartTime;

      _this5.duration = _this5.isPaused() ? _this5.duration : _this5.lastDuration + t, _this5.emit("record-progress", _this5.duration);
    }));
    return _this5;
  }

  _createClass(o, [{
    key: "renderMicStream",
    value: function renderMicStream(t) {
      var _this6 = this;

      var i = new AudioContext(),
          e = i.createMediaStreamSource(t),
          s = i.createAnalyser();
      e.connect(s);

      var r = s.frequencyBinCount,
          _o2 = new Float32Array(r);

      var n;

      var a = Math.floor((this.options.scrollingWaveformWindow || 0) * i.sampleRate),
          d = function d() {
        var t;
        if (_this6.isWaveformPaused) return void (n = requestAnimationFrame(d));

        if (s.getFloatTimeDomainData(_o2), _this6.options.scrollingWaveform) {
          var _t = Math.min(a, _this6.dataWindow ? _this6.dataWindow.length + r : r),
              _i7 = new Float32Array(a);

          if (_this6.dataWindow) {
            var _e3 = Math.max(0, a - _this6.dataWindow.length);

            _i7.set(_this6.dataWindow.slice(-_t + r), _e3);
          }

          _i7.set(_o2, a - r), _this6.dataWindow = _i7;
        } else _this6.dataWindow = _o2;

        var i = _this6.options.scrollingWaveformWindow;
        _this6.wavesurfer && (null !== (t = _this6.originalOptions) && void 0 !== t || (_this6.originalOptions = {
          cursorWidth: _this6.wavesurfer.options.cursorWidth,
          interact: _this6.wavesurfer.options.interact
        }), _this6.wavesurfer.options.cursorWidth = 0, _this6.wavesurfer.options.interact = !1, _this6.wavesurfer.load("", [_this6.dataWindow], i)), n = requestAnimationFrame(d);
      };

      return d(), {
        onDestroy: function onDestroy() {
          cancelAnimationFrame(n), null == e || e.disconnect(), null == i || i.close();
        },
        onEnd: function onEnd() {
          _this6.isWaveformPaused = !0, cancelAnimationFrame(n), _this6.stopMic();
        }
      };
    }
  }, {
    key: "startMic",
    value: function startMic(i) {
      return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t, _this$renderMicStream, e, s;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.mediaDevices.getUserMedia({
                  audio: !(null == i ? void 0 : i.deviceId) || {
                    deviceId: i.deviceId
                  }
                });

              case 3:
                t = _context.sent;
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                throw new Error("Error accessing the microphone: " + _context.t0.message);

              case 9:
                _this$renderMicStream = this.renderMicStream(t), e = _this$renderMicStream.onDestroy, s = _this$renderMicStream.onEnd;
                return _context.abrupt("return", (this.subscriptions.push(this.once("destroy", e)), this.subscriptions.push(this.once("record-end", s)), this.stream = t, t));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));
    }
  }, {
    key: "stopMic",
    value: function stopMic() {
      this.stream && (this.stream.getTracks().forEach(function (t) {
        return t.stop();
      }), this.stream = null, this.mediaRecorder = null);
    }
  }, {
    key: "startRecording",
    value: function startRecording(i) {
      return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this7 = this;

        var t, e, s, o;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this.stream;

                if (_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.startMic(i);

              case 4:
                _context2.t0 = _context2.sent;

              case 5:
                t = _context2.t0;
                this.dataWindow = null;
                e = this.mediaRecorder || new MediaRecorder(t, {
                  mimeType: this.options.mimeType || r.find(function (t) {
                    return MediaRecorder.isTypeSupported(t);
                  }),
                  audioBitsPerSecond: this.options.audioBitsPerSecond
                });
                this.mediaRecorder = e, this.stopRecording();
                s = [];

                e.ondataavailable = function (t) {
                  t.data.size > 0 && s.push(t.data);
                };

                o = function o(t) {
                  var i;
                  var r = new Blob(s, {
                    type: e.mimeType
                  });
                  _this7.emit(t, r), _this7.options.renderRecordedAudio && (_this7.applyOriginalOptionsIfNeeded(), null === (i = _this7.wavesurfer) || void 0 === i || i.load(URL.createObjectURL(r)));
                };

                e.onpause = function () {
                  return o("record-pause");
                }, e.onstop = function () {
                  return o("record-end");
                }, e.start(), this.lastStartTime = performance.now(), this.lastDuration = 0, this.duration = 0, this.isWaveformPaused = !1, this.timer.start(), this.emit("record-start");

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.duration;
    }
  }, {
    key: "isRecording",
    value: function isRecording() {
      var t;
      return "recording" === (null === (t = this.mediaRecorder) || void 0 === t ? void 0 : t.state);
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      var t;
      return "paused" === (null === (t = this.mediaRecorder) || void 0 === t ? void 0 : t.state);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      var t;
      return "inactive" !== (null === (t = this.mediaRecorder) || void 0 === t ? void 0 : t.state);
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var t;
      this.isActive() && (null === (t = this.mediaRecorder) || void 0 === t || t.stop(), this.timer.stop());
    }
  }, {
    key: "pauseRecording",
    value: function pauseRecording() {
      var t, i;
      this.isRecording() && (this.isWaveformPaused = !0, null === (t = this.mediaRecorder) || void 0 === t || t.requestData(), null === (i = this.mediaRecorder) || void 0 === i || i.pause(), this.timer.stop(), this.lastDuration = this.duration);
    }
  }, {
    key: "resumeRecording",
    value: function resumeRecording() {
      var t;
      this.isPaused() && (this.isWaveformPaused = !1, null === (t = this.mediaRecorder) || void 0 === t || t.resume(), this.timer.start(), this.lastStartTime = performance.now(), this.emit("record-resume"));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.applyOriginalOptionsIfNeeded(), _get(_getPrototypeOf(o.prototype), "destroy", this).call(this), this.stopRecording(), this.stopMic();
    }
  }, {
    key: "applyOriginalOptionsIfNeeded",
    value: function applyOriginalOptionsIfNeeded() {
      this.wavesurfer && this.originalOptions && (this.wavesurfer.options.cursorWidth = this.originalOptions.cursorWidth, this.wavesurfer.options.interact = this.originalOptions.interact, delete this.originalOptions);
    }
  }], [{
    key: "create",
    value: function create(t) {
      return new o(t || {});
    }
  }, {
    key: "getAvailableAudioDevices",
    value: function getAvailableAudioDevices() {
      return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", navigator.mediaDevices.enumerateDevices().then(function (t) {
                  return t.filter(function (t) {
                    return "audioinput" === t.kind;
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }]);

  return o;
}(e);

export { o as default };